module.exports = __webpack_public_path__ + "img/ear04.e6abaa35.png";